import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd831032"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "d-flex flex-column success h-100"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"padding-top:2.25rem;\" data-v-bd831032><i class=\"bi bi-emoji-smile\" style=\"font-size:2.5rem;\" data-v-bd831032></i></div><div class=\"flex-grow-1\" style=\"font-size:3.25rem;line-height:1.25;\" data-v-bd831032> Yaayy! Dein Foto wurde in die Galerie geladen! </div><div class=\"d-flex flex-column w-100\" data-v-bd831032><a href=\"/\" data-v-bd831032><button class=\"button-primary\" style=\"margin-bottom:1rem;\" data-v-bd831032> Weiter knipsen   <i class=\"bi bi-camera\" data-v-bd831032></i></button></a><a href=\"/gallery\" data-v-bd831032><button data-v-bd831032> Zur Galerie   <i class=\"bi bi-images\" data-v-bd831032></i></button></a></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]
const _hoisted_6 = {
  key: 2,
  class: "error"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" nay... ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]


import Spinner from '@/components/Spinner.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  status: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (__props.status >= 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["d-flex h-100 w-100 justify-content-center align-items-center", {'bg-sady': __props.status === 0, 'bg-sady': __props.status === 1, 'bg-warny': __props.status=== 2}]),
        style: {"padding":"1.5rem"}
      }, [
        (__props.status === 0)
          ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
          : _createCommentVNode("", true),
        (__props.status === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
          : _createCommentVNode("", true),
        (__props.status === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})